<template>
  <div class="Search-engine-skeleton">
    <div aria-hidden="true" class="Search-engine-skeleton__details">
      <ux-atoms-typo :text="$t('ux.molecules.searchEngine.wherePlaceholder')" as="p" variant="text-small" />
      <ux-atoms-typo as="p" color="light" variant="text-small"
        >{{ defaultDate }} • {{ $t('ux.molecules.searchEngine.people', { n: BOOKING_FUNNEL_DEFAULT }) }}
      </ux-atoms-typo>
    </div>
    <ux-atoms-icon :description="$t('ux.molecules.searchEngine.search')" class="Search-engine-skeleton__details" name="search-rounded" size="xl" />
  </div>
</template>

<script lang="ts" setup>
import { BOOKING_FUNNEL_DEFAULT } from '~/core/constants';
import { dateClassic, newUTCDate } from '~/helpers/date';

const defaultDate = computed(() => dateClassic(newUTCDate()));
</script>

<style lang="scss" scoped>
@use './SearchEngineSkeleton.scss';
</style>
